export const IDS = {
    //paths
    pnpSettingsDocumentTypeGrid: 'pnpSettingsDocumentTypeGrid',

    // tiles states:
    app_policies_settings_dashboard: 'app.policies.settings.dashboard',

    // settings type states :
    app_policies_settings_document_types: 'app.policies.settings.document_types',
    app_policies_settings_document_types_dashboard: 'app.policies.settings.document_types.dashboard',
    app_policies_settings_document_types_add: 'app.policies.settings.document_types.add',
    app_policies_settings_document_types_manage: 'app.policies.settings.document_types.manage',

    // settings categories states :
    app_policies_settings_categories: 'app.policies.settings.categories',
    app_policies_settings_categories_dashboard: 'app.policies.settings.categories.dashboard',


    // settings approval workflow states :
    app_policies_settings_approval_workflows: 'app.policies.settings.approval_workflows',
    app_policies_settings_approval_workflows_dashboard: 'app.policies.settings.approval_workflows.dashboard',

    // compliance report state
    app_policies_settings_compliance_report: 'app.policies.settings.compliance_report',

};